import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { provideStates } from '@ngxs/store';
import { SelectorComponent } from '@shared/components/selector/selector.component';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { DynamicModalModule } from '@shared/modules/dynamic-modal/dynamic-modal.module';
import { SecondsCounterPipe } from '@shared/pipes/seconds-counter.pipe';
import { ResponseLoggerComponent } from './response-logger.component';
import { responseLoggerInterceptor } from './response-logger.interceptor';
import { ResponseLoggerState } from './state/response-logger.state';

@NgModule({
  imports: [
    CommonModule,
    DynamicModalModule,
    SelectorComponent,
    TypedTemplateDirective,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    SecondsCounterPipe,
    ResponseLoggerComponent
  ],
  providers: [
    provideStates([ResponseLoggerState]),
    provideHttpClient(withXhr(), withInterceptors([responseLoggerInterceptor]))
  ]
})
export class ResponseLoggerModule {}
